import { Component, Input } from '@angular/core';
import { CopyTextComponent } from '@shared/components/atoms/copy-text/copy-text.component';
import { DefaultPlaceholderDirective } from '@shared/directives/default-placeholder.directive';
import { DynamicImgUrlDirective } from '@shared/directives/dynamic-img-url.directive';
import { UnsavedFormCheckDirective } from '@shared/directives/unsaved-form-check.directive';

@Component({
  selector: 'app-organization-logo',
  templateUrl: './organization-logo.component.html',
  imports: [
    UnsavedFormCheckDirective,
    DefaultPlaceholderDirective,
    DynamicImgUrlDirective,
    CopyTextComponent,
  ],
})
export class OrganizationLogoComponent {
  @Input() organizationLogo: string;

  @Input() alt = '';

  @Input() filterTokenUrl = '';

  @Input() showCopyText = false;

  @Input() windowOrigin: string = globalThis.origin;

  @Input() redirectEnabled = true;
}
